import {
  AppBar,
  Container,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Grid,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect } from "react";
import useStyle from "./style/Style";
import Movies from "./components/Movies"; 

const API_URL = "https://www.omdbapi.com?apikey=b6003d8a"; //url for fetch data from the omdb server

const App = () => {
  const classes = useStyle(); //styling the mui components
  const [search, setSearch] = useState("");
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    searchMovies("Batman"); //at the loading of page, results for batman will be displayed
  }, []);

  const searchMovies = async (title) => {
    const response = await fetch(`${API_URL}&s=${title}`); //fetching data's film from the server
    const data = await response.json();
    setMovies(data.Search); //setting state with the values of the server response
  };

  return (
    <div className="app">
      <header>
        <AppBar> 
          <Toolbar>
            <Typography className={classes.Title} variant="h4">
              {" "}
              MoviesViewer{" "}
            </Typography>
            <TextField
              label="Search a movie"
              variant="standard"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress = {(e) => {if(e.key === "Enter") searchMovies(search)}} //keyboard support. You can press enter instead of clicking the icon
              ></TextField> 
            <IconButton
              className={classes.IconButton}
              onClick={() => searchMovies(search)} //when pressed it call the function and data will be displayed
            >
              <SearchIcon></SearchIcon>
            </IconButton>
          </Toolbar>
        </AppBar>
      </header>
      <main>
        <Container className={classes.CardGrid} maxWidth="md">
          {movies !== undefined ? ( //if the returned data is undefined, nothing will be displayed
            <Grid container spacing={4}>
              {movies.map((movie, index) => {//iterating the movies array
                return (
                  <Grid item key={index} xs={12} sm={6} md={4}>
                    <Movies movies={movie}></Movies> {/* display data */}
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <div className={classes.error}>
              <Typography variant="h2"> No movies found </Typography>
            </div>
          )}
        </Container>
      </main>
    </div>
  );
};

export default App;
